import { render, staticRenderFns } from "./BillOfLandingLine.vue?vue&type=template&id=287652a3&scoped=true"
import script from "./BillOfLandingLine.vue?vue&type=script&lang=js"
export * from "./BillOfLandingLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287652a3",
  null
  
)

export default component.exports